import { render, staticRenderFns } from "./personalTree.vue?vue&type=template&id=e47c2e14&scoped=true"
import script from "./personalTree.vue?vue&type=script&lang=js"
export * from "./personalTree.vue?vue&type=script&lang=js"
import style0 from "./personalTree.vue?vue&type=style&index=0&id=e47c2e14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47c2e14",
  null
  
)

export default component.exports